import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import "./navbar.scss";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  return (
    <nav className="position-sticky top-0 bg-black d-flex justify-content-between shadow-lg">
      <NavLink className="nav-link" to="/">
        <img src="/assets/logo-niks-production.png" className="App-logo my-3 me-0" alt="logo"/>
      </NavLink>
      <div className="mobile-menu-icon d-md-none d-flex justify-content-end align-items-center me-0 px-3"
           onClick={toggleMenu}>
        <i className="bi bi-list text-light"></i>
      </div>
      <div className="d-none d-md-flex align-items-center">
        <NavLink className="nav-link" to="/">{t("navbar.home")}</NavLink>
        <NavLink className="nav-link" to="/movies">{t("navbar.movies")}</NavLink>
        <NavLink className="nav-link" to="/about">{t("navbar.about")}</NavLink>
        <NavLink className="nav-link" to="/contact">{t("navbar.contact")}</NavLink>
      </div>

      {mobileMenuOpen && (
        <div
          className="mobile-menu position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75 d-flex flex-column justify-content-center align-items-center text-center">
          <i
            className="mobile-menu-icon bi bi-x text-white position-absolute top-0 end-0 translate-middle-x mt-5"
            onClick={toggleMenu}
          ></i>
          <NavLink className="nav-link text-light my-2" onClick={toggleMenu} to="/">{t("navbar.home")}</NavLink>
          <NavLink className="nav-link text-light my-2" onClick={toggleMenu}
                   to="/movies">{t("navbar.movies")}</NavLink>
          <NavLink className="nav-link text-light my-2" onClick={toggleMenu} to="/about">{t("navbar.about")}</NavLink>
          <NavLink className="nav-link text-light my-2" onClick={toggleMenu}
                   to="/contact">{t("navbar.contact")}</NavLink>
        </div>
      )}
    </nav>
  )
    ;
};